// Author LFT
// Date 2020-12-22 11:18:04

class SithMesReportTemplate {
constructor({
        id = null,
        templateName = '',
        template = '',
        templateConfig = '',
        templateType = '',
        userId = '',
        templateFileName = '',
        templateRuntimeConfig = '',
        dirPath = '',
        cronExpression = '',
        scheduleStatus = '',
        jobId = '',
        remark = ''}
= {}) {
    this.id = id;
    this.templateName = templateName;
    this.template = template;
    this.templateConfig = templateConfig;
    this.templateType = templateType;
    this.userId = userId;
    this.templateFileName = templateFileName;
    this.templateRuntimeConfig = templateRuntimeConfig;
    this.dirPath = dirPath;
    this.cronExpression = cronExpression;
    this.scheduleStatus = scheduleStatus;
    this.jobId = jobId;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesReportTemplate();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'templateName',
        label: 'label.sith.mst.sithMesReportTemplate.grid.templateName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'template',
        label: 'label.sith.mst.sithMesReportTemplate.grid.template',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'templateConfig',
        label: 'label.sith.mst.sithMesReportTemplate.grid.templateConfig',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'templateType',
        label: 'label.sith.mst.sithMesReportTemplate.grid.templateType',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'userId',
        label: 'label.sith.mst.sithMesReportTemplate.grid.userId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'templateFileName',
        label: 'label.sith.mst.sithMesReportTemplate.grid.templateFileName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'templateRuntimeConfig',
        label: 'label.sith.mst.sithMesReportTemplate.grid.templateRuntimeConfig',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'dirPath',
        label: 'label.sith.mst.sithMesReportTemplate.grid.dirPath',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'cronExpression',
        label: 'label.sith.mst.sithMesReportTemplate.grid.cronExpression',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'scheduleStatus',
        label: 'label.sith.mst.sithMesReportTemplate.grid.scheduleStatus',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'jobId',
        label: 'label.sith.mst.sithMesReportTemplate.grid.jobId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesReportTemplate.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    templateNameFilter : "",
    templateFilter : "",
    templateConfigFilter : "",
    templateTypeFilter : "",
    userIdFilter : "",
    templateFileNameFilter : "",
    templateRuntimeConfigFilter : "",
    dirPathFilter : "",
    cronExpressionFilter : "",
    scheduleStatusFilter : "",
    jobIdFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'templateNameFilter',
        label: 'label.sith.mst.sithMesReportTemplate.filter.templateName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'templateFilter',
        label: 'label.sith.mst.sithMesReportTemplate.filter.template',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'templateConfigFilter',
        label: 'label.sith.mst.sithMesReportTemplate.filter.templateConfig',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'templateTypeFilter',
        label: 'label.sith.mst.sithMesReportTemplate.filter.templateType',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'userIdFilter',
        label: 'label.sith.mst.sithMesReportTemplate.filter.userId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'templateFileNameFilter',
        label: 'label.sith.mst.sithMesReportTemplate.filter.templateFileName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'templateRuntimeConfigFilter',
        label: 'label.sith.mst.sithMesReportTemplate.filter.templateRuntimeConfig',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'dirPathFilter',
        label: 'label.sith.mst.sithMesReportTemplate.filter.dirPath',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'cronExpressionFilter',
        label: 'label.sith.mst.sithMesReportTemplate.filter.cronExpression',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'scheduleStatusFilter',
        label: 'label.sith.mst.sithMesReportTemplate.filter.scheduleStatus',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'jobIdFilter',
        label: 'label.sith.mst.sithMesReportTemplate.filter.jobId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'templateName',
        label: 'label.sith.mst.sithMesReportTemplate.entity.templateName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'template',
        label: 'label.sith.mst.sithMesReportTemplate.entity.template',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'templateConfig',
        label: 'label.sith.mst.sithMesReportTemplate.entity.templateConfig',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'templateType',
        label: 'label.sith.mst.sithMesReportTemplate.entity.templateType',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'userId',
        label: 'label.sith.mst.sithMesReportTemplate.entity.userId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'templateFileName',
        label: 'label.sith.mst.sithMesReportTemplate.entity.templateFileName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'templateRuntimeConfig',
        label: 'label.sith.mst.sithMesReportTemplate.entity.templateRuntimeConfig',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'dirPath',
        label: 'label.sith.mst.sithMesReportTemplate.entity.dirPath',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'cronExpression',
        label: 'label.sith.mst.sithMesReportTemplate.entity.cronExpression',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'scheduleStatus',
        label: 'label.sith.mst.sithMesReportTemplate.entity.scheduleStatus',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'jobId',
        label: 'label.sith.mst.sithMesReportTemplate.entity.jobId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesReportTemplate.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesReportTemplate, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
